'use client';

import { createContext, useContext } from 'react';

export interface ToggleGroupContextValue {
  type: 'single' | 'multi';
  disabled: boolean;
  isPressed: (value: string) => boolean;
  onToggle: (value: string) => void;
}

export const ToggleGroupContext = createContext<ToggleGroupContextValue | null>(
  null,
);

export function useToggleGroup(): ToggleGroupContextValue {
  const ctx = useContext(ToggleGroupContext);
  if (!ctx) {
    throw new Error('<ToggleItem>은 <ToggleGroup> 내부에서 사용해야 합니다.');
  }
  return ctx;
}
